import { Reveal } from "@/components/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  {
    q: "How does the screening programme work?",
    a: "We visit your school and screen up to 10 students per visit — quietly and quickly, with teacher input and written parent consent. You receive a clear summary of who needs support, and why.",
  },
  {
    q: "What ages and needs do you support?",
    a: "From pre-primary through high school: speech delays, articulation difficulties, language disorders, fluency (stammering), autism spectrum support, learning support needs, hearing impairment, and social communication.",
  },
  {
    q: "Do parents need to travel?",
    a: "No. Every session happens inside your school — group or one-to-one — timetabled around the school day. Parents receive monthly reports and join review meetings without any travel.",
  },
  {
    q: "How do we track progress?",
    a: "You receive plain-language written reports every month, for both parents and management. Every four weeks we sit down together to review progress and adjust each child's plan.",
  },
  {
    q: "How is pricing structured?",
    a: "Programmes are shaped around your timetable and budget, so pricing is shared privately after a free consult. There's no commitment to start a conversation.",
  },
];

export const Faq = () => (
  <section id="faq" className="border-y border-pine-900/10 bg-sand py-24 lg:py-32">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-5 sm:px-8 lg:grid-cols-12">
      <Reveal className="lg:col-span-5">
        <p className="mb-4 font-mono text-xs font-medium uppercase tracking-[0.28em] text-pine-700">Questions, answered</p>
        <h2 className="font-serif text-2xl font-semibold tracking-tight text-pine-950 sm:text-3xl lg:text-4xl">
          Everything families and districts ask us first.
        </h2>
        <p className="mt-5 max-w-md text-sm leading-relaxed text-stone-600 sm:text-base">
          Can't find your answer? Send us a note below — a clinician, not a bot,
          replies within one business day.
        </p>
      </Reveal>

      <Reveal className="lg:col-span-7" delay={0.1}>
        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid="faq-accordion-item"
              className="border-b border-pine-900/15"
            >
              <AccordionTrigger className="py-6 text-left font-serif text-lg font-semibold text-pine-950 hover:text-pine-700 hover:no-underline sm:text-xl">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-sm leading-relaxed text-stone-600 sm:text-base">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
